(function () {
  var root = document.getElementById('veyra-discount-quiz');
  if (!root) return;

  var preview = window.location.search.indexOf('veyra_offer_preview=true') > -1;
  var storageKey = 'veyra_45_offer_dismissed_at';
  var week = 7 * 24 * 60 * 60 * 1000;
  var delay = Number(root.dataset.delayMs || 5000);
  var remainingDelay = preview ? 250 : delay;
  var timer = null;
  var countdownStartedAt = 0;

  function recentlyDismissed() {
    if (preview) return false;
    try { return Date.now() - Number(localStorage.getItem(storageKey) || 0) < week; } catch (error) { return false; }
  }

  function close(remember) {
    root.hidden = true;
    document.body.classList.remove('veyra-offer-open');
    if (remember) { try { localStorage.setItem(storageKey, String(Date.now())); } catch (error) {} }
  }

  function open() {
    if (window.location.pathname.indexOf('/cart') === 0 || recentlyDismissed()) return;
    if (birthdayPopupIsOpen()) {
      scheduleCountdown();
      return;
    }
    root.hidden = false;
    document.body.classList.add('veyra-offer-open');
    root.querySelector('.veyra-offer__close')?.focus();
  }

  function birthdayPopupIsOpen() {
    return document.body.classList.contains('iv-birthday-popup-open');
  }

  function pauseCountdown() {
    if (timer === null) return;
    remainingDelay = Math.max(0, remainingDelay - (Date.now() - countdownStartedAt));
    window.clearTimeout(timer);
    timer = null;
  }

  function scheduleCountdown() {
    if (timer !== null || recentlyDismissed() || window.location.pathname.indexOf('/cart') === 0) return;
    if (birthdayPopupIsOpen()) return;

    countdownStartedAt = Date.now();
    timer = window.setTimeout(function () {
      timer = null;
      open();
    }, remainingDelay);
  }

  function handleBirthdayOpen() {
    pauseCountdown();

    // Safety net if either delay is changed later.
    if (!root.hidden) {
      close(false);
      remainingDelay = delay;
    }
  }

  function handleBirthdayClose() {
    scheduleCountdown();
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-veyra-offer-close]')) close(true);
    if (event.target.closest('[data-veyra-offer-claim]')) close(true);
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !root.hidden) close(true); });
  document.addEventListener('inga:birthday-popup:open', handleBirthdayOpen);
  document.addEventListener('inga:birthday-popup:close', handleBirthdayClose);
  scheduleCountdown();
})();
